import styles from './AttachmentsTabPanel.module.scss';

import {
  AttachmentProps,
  Attachments,
} from '@work4all/components/lib/components/attachments';

import { useTableLayoutState } from '../../../../../../../../components/data-tables/table-layout';
import { Panel } from '../../../../../components/panel/Panel';
import { useMaskContext } from '../../../../../hooks/mask-context';

const VISIBLE_COLUMNS: AttachmentProps['visibleColumns'] = [
  'filesize',
  'type',
  'filename',
  'date',
];

export const AttachmentsTabPanel = () => {
  const [tableLayout] = useTableLayoutState();
  const mask = useMaskContext();

  return (
    <Panel className={styles.maxHeight}>
      <Attachments
        entity={mask.entity}
        tableLayout={tableLayout}
        visibleColumns={VISIBLE_COLUMNS}
      />
    </Panel>
  );
};
